import { useState, useEffect } from 'react';
import ToggleForm from '../../components/toggle/ToggleForm';
import { filterUndefined } from '../../utils/FilterUndefinedObject';

const defaultProps = {
  profile: {},
  onChangeCallback: () => {},
};

const Accessibe = (props) => {
  const mergedProps = { ...defaultProps, ...filterUndefined(props) };
  const { profile, onChangeCallback } = mergedProps;
  const [toggle, setToggle] = useState(profile.accessibeOn);

  // When mounting and changing a student.
  useEffect(() => {
    setToggle(profile.accessibeOn);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [profile.id]);

  const handleOnchange = (_field, newValue) => {
    if (newValue === null) return;
    setToggle(newValue);
    onChangeCallback(newValue);
  };

  return (
    <ToggleForm value={toggle} handleOnChange={handleOnchange} data-test='accessibe-toggle' />
  );
};

export default Accessibe;
